// extracted by mini-css-extract-plugin
export var signinContainer = "signin-module--signinContainer--2dHOu";
export var formGroup = "signin-module--formGroup--2IBYu";
export var privacyPolicy = "signin-module--privacyPolicy--PvuwB";
export var links = "signin-module--links--1Z0NB";
export var notice = "signin-module--notice--3Ucmp";
export var error = "signin-module--error--26E6p";